module.exports = __webpack_public_path__ + "static/media/Ripplematch.196217dd.svg";